import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { SessionService } from "src/app/store/session/session.service";

@Component({
  selector: "app-authorization",
  templateUrl: './authorization.component.html',
  styleUrls: ['./authorization.component.scss']
})
export class AuthorizationComponent implements OnInit {
  constructor(private sessionService: SessionService,
    private router: Router,
    private route: ActivatedRoute) { }

  ngOnInit() {
    localStorage.clear();
    this.sessionService.logout();

    this.route.queryParams.subscribe(params => {
      const accessToken = params['access_token'];
      const expiresIn = params['expires_in'];
      const refreshToken = params['refresh_token'];
      const returnUrl = params['redirect_uri'];

      this.sessionService.loginAuthorization(accessToken, refreshToken, expiresIn, returnUrl);

    });
  }
}
